export default __webpack_public_path__ + "static/media/des-7.701db752.jpg";